import { render } from "./index.vue?vue&type=template&id=606bce38&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.vue?vue&type=style&index=0&id=606bce38&lang=scss&scoped=true"

import exportComponent from "/Users/kgeek/KGEEK/PERSONNAL/REMA/traning_lists/scm/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-606bce38"]])

export default __exports__